import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How is this different from practicing with a friend?',
      answer: 'Our interviewers are senior engineers who have conducted hundreds of real interviews at top companies. They know exactly what hiring managers look for and can spot issues you might miss. Plus, they provide objective, honest feedback without worrying about hurting your feelings.'
    },
    {
      question: 'What if I\'m not ready yet? Should I wait?',
      answer: 'Actually, the best time for a mock interview is BEFORE you feel ready. That\'s when you get the most value - you\'ll discover what you need to work on and have time to improve. Waiting until you\'re "ready" means missing out on crucial feedback that could save you from failing real interviews.'
    },
    {
      question: 'How soon can I book a session?',
      answer: 'Most sessions can be scheduled within 2-3 days. If you have an urgent interview coming up, contact us and we\'ll do our best to accommodate you sooner. We understand that timing is critical when you have a real interview on the horizon.'
    },
    {
      question: 'What technology stack do you cover?',
      answer: 'We specialize in JavaScript, TypeScript, React, React Native, Node.js, and modern web development. We also cover fundamentals like data structures, algorithms, system design, and behavioral questions that apply to any tech role.'
    },
    {
      question: 'What if I freeze up or perform badly?',
      answer: 'That\'s exactly why you\'re here! The whole point is to make mistakes in a safe environment and learn from them. Our interviewers are supportive and will help you work through challenging moments. Remember: it\'s better to struggle here than in a real interview.'
    },
    {
      question: 'Do you help with resume and LinkedIn?',
      answer: 'Yes! Our Professional and Enterprise plans include resume review and LinkedIn optimization. We\'ll show you how to present your experience in a way that gets you more interviews and impresses recruiters.'
    },
    {
      question: 'Can I do multiple sessions?',
      answer: 'Absolutely! Many candidates book 2-3 sessions to practice different aspects (behavioral, technical, system design) or to see their improvement over time. Contact us for bundle pricing if you want multiple sessions.'
    },
    {
      question: 'How do I know if I\'m improving?',
      answer: 'You\'ll receive a detailed scorecard after each session with specific metrics. If you do multiple sessions, you can track your progress over time. Plus, you\'ll feel the difference in your confidence - and that\'s what matters most in the interview room.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="container mx-auto max-w-4xl px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Questions? We've Got Answers
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about mock interviews
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-lg text-gray-900 pr-8">
                  {faq.question}
                </span>
                <span className={`flex-shrink-0 text-2xl text-orange-600 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  ▼
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-700 leading-relaxed border-t border-gray-100 pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Still have questions CTA */}
        <div className="mt-12 text-center bg-white rounded-xl p-8 shadow-md">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            Still have questions?
          </h3>
          <p className="text-gray-600 mb-4">
            We're here to help. Reach out and we'll get back to you within 24 hours.
          </p>
          <a
            href="mailto:aitwobrains@gmail.com"
            className="inline-block px-6 py-3 bg-green-700 hover:bg-green-800 text-white font-semibold rounded-lg transition-colors"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
